import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, getToken, setToken, clearToken } from "./api";

const AuthCtx = createContext({});

export function AuthProvider({ children }) {
  const [token, setTok] = useState(getToken());
  const [authEnabled, setAuthEnabled] = useState(null); // null = checking

  useEffect(() => {
    let alive = true;
    api.authConfig()
      .then(c => { if (alive) setAuthEnabled(!!c.auth_enabled); })
      .catch(() => { if (alive) setAuthEnabled(true); }); // backend unreachable — fail closed
    return () => { alive = false; };
  }, []);

  // api.js interceptor clears the token on 401 (e.g. backend restarted) and fires this
  useEffect(() => {
    const onUnauthorized = () => setTok(null);
    window.addEventListener("oim:unauthorized", onUnauthorized);
    return () => window.removeEventListener("oim:unauthorized", onUnauthorized);
  }, []);

  const login = useCallback(async (username, password) => {
    const res = await api.login(username, password); // throws on bad credentials
    setToken(res.token);
    setTok(res.token);
    return res;
  }, []);

  const logout = useCallback(async () => {
    try { await api.logout(); } catch { /* session may already be gone */ }
    clearToken();
    setTok(null);
  }, []);

  const ready = authEnabled !== null;
  const isAuthed = authEnabled === false || !!token;

  return (
    <AuthCtx.Provider value={{ ready, isAuthed, authEnabled, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
